
export function formatSaveWizardRequest(
  requiredInfo,
  additionalInfo,
  currentUserShippingInfo,
  gclidValue,
  fbclidValue,
  formAnswers,
  recaptchaToken
) {
  /* formatting the wizard data */

  let requestData = {
    "recaptcha_token": recaptchaToken,
    "mcp_wizard_widget": 1,
    "billing[save_in_address_book]": 1,
    "billing[same_as_billing]": 1,
    "billing[street][]": [requiredInfo.adresse],
    "billing[country_id]": "FR",
    "billing[city]": requiredInfo.city,
    "billing[postcode]": requiredInfo.postalcode,
    "prefix": requiredInfo.prefix,
    "lastname": requiredInfo.lastname,
    "firstname": requiredInfo.firstname,
    "mcp_customer_professional": requiredInfo.isPro ? "on" : "off",
    "company": requiredInfo.company ?? "",
    "email": requiredInfo.email,
    "billing[telephone]": requiredInfo.phone,
    "customer-project-detail-checkbox": additionalInfo.commentInfo === true ? "1" : "0",
    "customer-project-detail": additionalInfo.comment_info,
    "widget_create_account": additionalInfo.createAccount,
    "proxiserve_optin": requiredInfo.proxiserve_optin,
    "form_answers": [],
    ...gclidValue,
    ...fbclidValue
  };

  if (currentUserShippingInfo) {
    requestData["billing[address_id]"] = currentUserShippingInfo.entityId
      ? `${currentUserShippingInfo.entityId}`
      : 0;
  }

  if (formAnswers.length) {
    requestData["form_answers"] = JSON.stringify(formAnswers);
  }

  /* preparing the form-data request */

  let bodyFormData = new FormData();
  Object.keys(requestData).forEach(key => {
    if (typeof requestData[key] === "string" || typeof requestData[key] === "number") {
      bodyFormData.append(key, requestData[key]);
    } else if (typeof requestData[key] === "object" && requestData[key].length) {
      requestData[key].forEach(value => bodyFormData.append(key, value));
    } else if (typeof requestData[key] === "boolean") {
      bodyFormData.append(key, +requestData[key]); // transform into 0|1
    }
  });

  return bodyFormData;
}